(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.currentScript.closest('.cro-reviews') || document.querySelector('.cro-reviews');
  if (!section) return;

  var track = section.querySelector('.cro-reviews__track');
  var prevBtn = section.querySelector('.cro-reviews__btn--prev');
  var nextBtn = section.querySelector('.cro-reviews__btn--next');
  var cards = track.querySelectorAll('.cro-reviews__card');
  var currentIndex = 0;

  function getVisible() {
    var w = section.querySelector('.cro-reviews__track-outer').offsetWidth;
    if (w < 750) return 1;
    if (w < 990) return 2;
    return 4;
  }

  function maxIndex() {
    return Math.max(0, cards.length - getVisible());
  }

  function go(idx) {
    var max = maxIndex();
    if (idx > max) idx = 0;
    if (idx < 0) idx = max;
    currentIndex = idx;
    var cardWidth = cards[0].offsetWidth + 16;
    track.style.transform = 'translateX(-' + (currentIndex * cardWidth) + 'px)';
  }

  prevBtn.addEventListener('click', function() { go(currentIndex - 1); });
  nextBtn.addEventListener('click', function() { go(currentIndex + 1); });
  window.addEventListener('resize', function() { go(currentIndex); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
